const gallery = [
  "/assets/img/gallery/gallery_1_1.jpg",
  "/assets/img/gallery/gallery_1_2.jpg",
  "/assets/img/gallery/gallery_1_3.jpg",
  "/assets/img/gallery/gallery_1_4.jpg",
  "/assets/img/gallery/gallery_1_5.jpg",
  "/assets/img/gallery/gallery_1_6.jpg",
  "/assets/img/gallery/gallery_1_7.jpg",
  "/assets/img/gallery/gallery_1_8.jpg",
  "/assets/img/gallery/gallery_1_9.jpg",
];

export default gallery;
